export default __webpack_public_path__ + "static/media/white-cotality-logo.63a17105.svg";